// extracted by mini-css-extract-plugin
module.exports = {"modal":"EditModal_modal__2KONI"};